import $ from "jquery";

const initializeModals = () => {
  // Helper class to handle Inert attribute of a modal
  const handleModalInert = (elem, hide) => {
    if (!elem) {
      return;
    }

    if (hide) {
      $(elem).attr("inert");
    } else {
      $(elem).removeAttr("inert");
    }
  };

  /**
   * Some modals have transition animations on open and close
   * This helper function manages state when modal is ready for interaction after transition is complete
   * @param {string} modalId
   * @param {boolean} readyState
   * @returns {void}
   */
  const modalTransitionState = (modalId, readyState = false) => {
    if (!modalId) {
      console.warn("Modal ID is required for managing transition state");
      return;
    }
    $(modalId).one("transitionend", function () {
      $(modalId).data("ready", readyState);
    });
  };

  /**
   *
   * @param {*} modalId string ID
   * @param {*} modalToggleClass Given class for toggling modal open or close
   * @param {*} openButtonsClass Button class that opens the modal
   * @param {*} closeButtons Button class that closes the modal
   * @param {*} openCallback Callback function when modal is opened
   * @param {*} closeCallback Callback function when modal is closed
   * @returns {void}
   * @description Initialize the modal with the given parameters
   */
  const initialize = ({
    modalId,
    modalToggleClass,
    openButtonsClass,
    closeButtonsClass,
    openCallback = () => {},
    closeCallback = () => {},
  }) => {
    const modal = document.getElementById(modalId);
    const openButtons = document.querySelectorAll(openButtonsClass);
    const closeButtons = document.querySelectorAll(closeButtonsClass);

    if (!modal || !modalToggleClass || !openButtons?.length) {
      return;
    }

    const modalClasses = modal.classList;
    const modalCloseClass = "show";
    const jqueryId = "#" + modalId;

    [...openButtons].forEach((btn) => {
      btn.addEventListener("click", function (evt) {
        evt.preventDefault();
        const bodyClasses = document.body.classList;

        if (bodyClasses.contains(modalToggleClass)) {
          handleModalInert(jqueryId, true);
          bodyClasses.remove(modalToggleClass);
          modalClasses.remove(modalCloseClass);
          modalTransitionState(jqueryId, false);
          closeCallback();
        } else {
          handleModalInert(jqueryId, false);
          bodyClasses.add(modalToggleClass);
          modalClasses.add(modalCloseClass);
          modalTransitionState(jqueryId, true);
          openCallback();
        }
      });
    });

    if (closeButtons?.length) {
      // Initialize close modal buttons
      closeButtons.forEach((button) => {
        button.addEventListener("click", function (evt) {
          evt.preventDefault();
          handleModalInert(modalId, true);
          const bodyClasses = document.body.classList;
          bodyClasses.remove(modalToggleClass);
          modalClasses.remove(modalCloseClass);
          modalTransitionState(jqueryId, false);
          closeCallback();
        });
      });
    }
  };

  const handleApplicationModals = (appModals) => {
    appModals.each(function () {
      const modal = $(this);

      // check if modal has open-on-load class
      if (modal.hasClass("open-on-load")) {
        modal.modal("show");
        $(".hoas-application-popup-overlay").fadeIn();
      }

      modal.on("hidden.bs.modal", () => {
        $(".hoas-application-popup-overlay").fadeOut();
      });

      modal.find('[data-action="close"]').on("click", () => {
        modal.modal("hide");
      });
    });
    // listen to escape key, and close all .hoas-application-popup modals and overlays
    $(document).on("keydown", (e) => {
      if (e.key === "Escape") {
        $(".hoas-application-popup:not(.force-open)").modal("hide");
        $(".hoas-application-popup-overlay:not(.force-open)").fadeOut();
      }
    });
    // listen to click on overlay, and close all .hoas-application-popup modals and overlays
    $(".hoas-application-popup-overlay").on("click", () => {
      $(".hoas-application-popup:not(.force-open)").modal("hide");
      $(".hoas-application-popup-overlay:not(.force-open)").fadeOut();
    });
  };

  const handleModalTriggers = (triggers) => {
    triggers.forEach((trigger) => {
      let modalElId = trigger.getAttribute("data-target");
      modalElId = modalElId.replace("#", "");
      const modalEl = document.getElementById(modalElId);

      if (!modalEl) {
        return;
      }
      // Detect class changes in modal and when shown add focus to first input if there is any
      const observer = new MutationObserver((event) => {
        if (!event[0].target) {
          return;
        }

        if (event[0].target.classList.contains("show")) {
          const input = event[0].target.querySelector("input");

          if (!input) {
            return;
          }
          input.focus();
        }
      });

      if (!observer) {
        return;
      }
      observer.observe(modalEl, {
        attributes: true,
        attributeFilter: ["class"],
        childList: false,
        characterData: false,
      });
    });
  };

  return {
    initialize: initialize,
    handleApplicationModals: handleApplicationModals,
    handleModalTriggers: handleModalTriggers,
  };
};

export default initializeModals;
